export default __webpack_public_path__ + "static/media/nik33.eda10549.png";